export const ARTICULAT_FONT_FAMILY = '"articulat-cf", "Helvetica Neue", Arial, sans-serif';
export const SPACE_GROTESK_FONT_FAMILY = '"Space Grotesk", "Helvetica Neue", Arial, sans-serif';
